import { render, staticRenderFns } from "./collageControl.vue?vue&type=template&id=219ff5b6&scoped=true&"
import script from "./collageControl.vue?vue&type=script&lang=js&"
export * from "./collageControl.vue?vue&type=script&lang=js&"
import style0 from "./collageControl.vue?vue&type=style&index=0&id=219ff5b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219ff5b6",
  null
  
)

export default component.exports